import React from "react";
import { FaStar } from "react-icons/fa";
import testimonialImg from "../../assets/patricia.jpg";
import { ImQuotesLeft, ImQuotesRight } from "react-icons/im";

const HomeTestimonial = ({ description, userImg, name, location }) => {
  return (
    <div className="flex flex-col justify-center items-center my-8">
      <div className="h-32 w-32 rounded-full drop-shadow-lg mb-4">
        <img
          src={userImg}
          alt={testimonialImg}
          className="h-full w-full object-cover rounded-full"
        />
      </div>
      <h2 className="font-bold text-xl mb-2">{name}</h2>
      <p className="text-gray-400 mb-2">{location}</p>
      <span className="flex text-amber-400 mb-4">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </span>
      <div className="items-center justify-evenly gap-32 inline-block lg:w-[30rem]">
        <div className="break-words relative font-bold">
          {/* You’ll get the best of what you put in. The tear is working at their best to provide us
          variety of spaces and homes. Had a great experience working with them. Thanks a lot. */}
          {description}
          <ImQuotesLeft className="absolute -left-4 -top-5 -z-10 text-7xl text-gray-200 hidden md:block" />
          <ImQuotesRight className="absolute -right-4 -bottom-4 -z-10 text-7xl text-gray-200 hidden md:block" />
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonial;
